import script from './component-lib.esm2.js';
import normalizeComponent from '../../external/vue-runtime-helpers/dist/component-lib.esm.js';
import createInjector from '../../external/vue-runtime-helpers/dist/inject-style/component-lib.esm.js';

/* script */
const __vue_script__ = script;

/* template */
var __vue_render__ = function () {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c('div', _vm._g(_vm._b({
    staticClass: "fancy-icon-circle",
    style: _vm.styles
  }, 'div', _vm.$attrs, false), _vm.$listeners), [_vm._t("default")], 2);
};
var __vue_staticRenderFns__ = [];

/* style */
const __vue_inject_styles__ = function (inject) {
  if (!inject) return;
  inject("data-v-e7f6fca4_0", {
    source: ".fancy-icon-circle[data-v-e7f6fca4]{align-items:center;background:var(--c-bg-color);border-radius:50%;color:var(--c-color);font-size:var(--c-font-size);display:inline-flex;height:calc(var(--c-font-size) * var(--c-multiplier));justify-content:center;width:calc(var(--c-font-size) * var(--c-multiplier))}",
    map: undefined,
    media: undefined
  });
};
/* scoped */
const __vue_scope_id__ = "data-v-e7f6fca4";
/* module identifier */
const __vue_module_identifier__ = undefined;
/* functional template */
const __vue_is_functional_template__ = false;
/* style inject SSR */

/* style inject shadow dom */

const __vue_component__ = /*#__PURE__*/normalizeComponent({
  render: __vue_render__,
  staticRenderFns: __vue_staticRenderFns__
}, __vue_inject_styles__, __vue_script__, __vue_scope_id__, __vue_is_functional_template__, __vue_module_identifier__, false, createInjector, undefined, undefined);
var FancyIconCircle = __vue_component__;
export { FancyIconCircle as default };